export default function TermCoverageLengths(isAmerico) {
  return isAmerico ? [
    { label: "5 Year Term", value: "5" },
    { label: "7 Year Term", value: "7" },
    { label: "10 Year Term", value: "10" },
    { label: "15 Year Term", value: "15" },
    { label: "20 Year Term", value: "20" },
    { label: "25 Year Term", value: "25" },
    { label: "30 Year Term", value: "30" },
  ] :
  [
    { label: "5 Year Term", value: "5" },
    { label: "7 Year Term", value: "7" },
    { label: "10 Year Term", value: "10" },
    { label: "15 Year Term", value: "15" },
    { label: "20 Year Term", value: "20" },
    { label: "25 Year Term", value: "25" },
    { label: "30 Year Term", value: "30" },
    { label: "35 Year Term", value: "35" },
    { label: "40 Year Term", value: "40" },
  ];
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageLengths/TermCoverageLengths.js